import { AnyAction } from 'redux';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';

export const gesamtpreisReducer = function (
  sectionState: number = null,
  action: AnyAction,
): number {
  switch (action.type) {
    case GlobalActions.ADD_PRODUKT_TO_ANGEBOTE: {
      return sectionState || 0;
    }

    default:
      return sectionState;
  }
};
